import React from 'react';
import './Grid-View.css';
import ScrollAnimation from 'react-animate-on-scroll';
import { NavLink } from 'react-router-dom';
import "animate.css/animate.min.css";
import Zdjecie from './Zdjecie';

const Grid = ( props ) => {
    let linia = {
    };
    let siatka = {};
    let fade = "fadeInUp";
    let anim = true;
    let duration = 0.5;
    let delay = 300;
    if (props.strona === "lewa") {
        linia.left= '50%'
        linia.top= '0'
    } else if (props.strona === "prawa") {
        linia.left= '0%'
        linia.top= '0'
    };
    if (window.innerHeight > window.innerWidth)
    {
        delay = 0;
        duration = 0;
        anim = false;
        fade = ' ';
    };
    if (!props.animatnion) {
        fade = ' ';
        anim = false;
    };
    let peepee = {};
    if (!props.fnot) {
        peepee.fontSize= '5em !important'
    }
    return (
        <div className="siatka" style={siatka}>
            <Zdjecie zdj={props.zdj} strona={props.strona} animatnion={anim} sign={props.sign}/>
            <ScrollAnimation animateIn={fade} initiallyVisible={!anim} animateOnce="true" className="inline" style={linia} delay={delay} duration={duration}>
                <div className="tekst">
                    <h2 className="naglowek">{props.naglowek}</h2>
                    <div>{props.children}<br></br>{/*<NavLink className="wiecej" to="/pokoje"> {props.more}</NavLink>*/}</div>
                </div>
            </ScrollAnimation>
        </div>
    );
}

export default Grid;


// WEBPACK FOOTER //
// ./src/Grid-View/Grid-View.js